export const cio_identify = (email = null) => {
  if (email) {
    window._cio.identify({ id: email })
  }
}
